import Api from './api'
import { AxiosResponse} from "axios";
import DynamicObject from "../models/dynamic-object";

export default (config?: DynamicObject): Promise<AxiosResponse> => {
    const path = 'wallet/history'
    return Api.getInstance().request.get(`${path}?Wallet%5Btype%5D=week&page=1`, path)
}

